import { Link } from "react-router-dom";
import { Sparkles, Hammer, Layers3, Swords, Bell } from "lucide-react";

const PILLARS = [
  { icon: Layers3, title: "Cartas propias", desc: "Un TCG original diseñado por la comunidad Nirvana." },
  { icon: Swords, title: "Modo de juego", desc: "Reglas, mecánicas y simulador de duelos en la plataforma." },
  { icon: Hammer, title: "Editor de cartas", desc: "Herramientas para crear, balancear y probar cartas." },
];

export default function ProtoTCGPage() {
  return (
    <div className="min-h-screen bg-black pt-24 pb-16 relative overflow-hidden" data-testid="proto-tcg-page">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-20 -left-20 w-96 h-96 rounded-full bg-cyan-500/10 blur-3xl" />
        <div className="absolute bottom-0 right-0 w-[500px] h-[500px] rounded-full bg-pink-500/10 blur-3xl" />
      </div>
      <div className="container mx-auto px-4 relative">
        <div className="max-w-3xl">
          <p className="text-xs tracking-[0.3em] text-cyan-400 font-bold mb-3 flex items-center gap-2"><Sparkles size={14} /> JUEGOS · EN CONSTRUCCIÓN</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black leading-none mb-4">
            <span className="bg-gradient-to-r from-cyan-400 via-blue-500 to-pink-500 bg-clip-text text-transparent">Proto TCG</span>
          </h1>
          <p className="text-gray-400 text-base md:text-lg mb-8">Este espacio está reservado para el nuevo juego de cartas que construiremos dentro de Nirvana TCG. Aquí vivirán sus reglas, cartas, mazos y torneos.</p>
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-cyan-500/15 border border-cyan-500/40 text-cyan-300 text-sm font-bold" data-testid="proto-tcg-badge">Beta · Próximamente</span>
        </div>

        <div className="grid sm:grid-cols-3 gap-5 mt-14">
          {PILLARS.map(({ icon: Icon, title, desc }, i) => (
            <div key={title} className="glass-card rounded-2xl p-6 border border-cyan-500/20 hover:border-cyan-400/50 transition-all hover:-translate-y-1" style={{ animationDelay: `${i * 120}ms` }} data-testid={`proto-pillar-${i}`}>
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-cyan-500 to-blue-600 flex items-center justify-center text-white mb-4"><Icon size={22} /></div>
              <h3 className="text-base md:text-lg font-black text-white mb-1">{title}</h3>
              <p className="text-sm text-gray-400">{desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-14 glass-card rounded-2xl p-6 md:p-8 border border-purple-500/30 flex flex-col md:flex-row items-center gap-6">
          <Bell size={36} className="text-yellow-400 flex-shrink-0" />
          <div className="flex-1">
            <h3 className="text-base md:text-lg font-black text-white">¿Quieres participar en el diseño?</h3>
            <p className="text-sm text-gray-400">Comparte tus ideas en la comunidad y sé parte del primer TCG creado en Nirvana.</p>
          </div>
          <Link to="/comunidad" className="px-5 py-3 rounded-xl bg-gradient-to-r from-pink-500 to-purple-600 text-white font-bold hover:shadow-lg hover:shadow-pink-500/30 transition" data-testid="proto-tcg-community-link">Ir a la comunidad</Link>
        </div>
      </div>
    </div>
  );
}
